import React from "react";


//Disponiblite étendu

const HtmlRenderImageICon: React.FC = () => {
 
  // const [showModal, setShowModal] = useState(false);
  // const [modalImage, setModalImage] = useState('');
  // const [modalName, setModalName] = useState('');



  return (
    <>
    
      <div
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        <i title="Aperçu" className="bi-file-image" style={{fontSize:"24px", marginBottom:"9px"}}></i>
        
      </div>

    </>
  );
};

export default HtmlRenderImageICon;
